import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kvtrup43jc: FaireBrandEntity = {
  token: "b_kvtrup43jc",
  type: "brand",
  name: "My Sauce Lab",
  avatarUrl:
    "https://cdn.faire.com/fastly/c52e193cf19a370b35c67a4ce09b0b5c8b7272f811821c8ca6d236ee6cd295af.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3e35e419ce6fd4442f4e5f8035d87ead3b919557f3ddae2b1980f4ecac95d087.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c52e193cf19a370b35c67a4ce09b0b5c8b7272f811821c8ca6d236ee6cd295af.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3e35e419ce6fd4442f4e5f8035d87ead3b919557f3ddae2b1980f4ecac95d087.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "My Sauce Lab is the product of three restaurant veterans, a saucey idea, and a kitchen. Proudly based in Nashville, Tennessee, the Saucey Scientists set out to bottle up the wild flavors of their world travels into unexpected combinations that add mouthwatering, saucey goodness to every bite. The rich and authentic sauces are vegan, gluten-free, and made with zero artificial preservatives. All the ingredients in My Sauce Lab are high quality and elevate any dish!\n \nMeet the sauces: \nSchezwan: The “good on everything” chutney. \n\nPandemonium: A diabolically red-hot sauce that is the wild child of hot sauces. \n\nLucifer: Sweet and spicy — the best of both worlds! \n\nImlee: A lip-smackingly tangy tamarind sauce. \n\nGreen Goodness: The goodness-gracious, spice-of-life sauce! \n\nEl Fuego: The new sriracha sauce that will have you saying, “It’s getting hot in here.” \n \nWe set out to create sauces that challenge your basic understanding of a hot sauce. The sauces from My Sauce Lab are complex and packed with flavors that will elevate your burgers, tacos, pizzas, salads, soups, and even scrambled eggs and any other dish or cuisine you crave. They also can be used in a multitude of ways – dressings, toppings, as marinades and even for cooking.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:45.111Z",
    importedBy: "entity-db-cli",
  },
};
